import React, { useEffect } from 'react'
import { useSearchParam } from 'react-use'
import { useHistory, useUser } from '@ztechapps/common.hook'
import { CenterScreen, LoadingContent } from '@ztechapps/webui.util'
import { routesDef } from '../../../config/routes'

/**
 * There is join functionality, as the user is automatically activated, so we can skip this
 * @constructor
 */
export const Page = () => {
  const { loading, loggedIn } = useUser()
  const history = useHistory()
  const redirectUrl = useSearchParam('redirect_url')

  useEffect(() => {
    if (loading) return
    if (loggedIn) {
      // Honor an incoming redirect_url (the anonymous-checkout-then-login flow) before defaulting to Home.
      return history.push(redirectUrl || routesDef.HomePage.path)
    }
  }, [loading, loggedIn, redirectUrl, history])

  return (
    <CenterScreen>
      <LoadingContent message="Redirecting to home page, please wait..." />
    </CenterScreen>
  )
}
